module.exports = __webpack_public_path__ + "static/media/Jackson St, San Francisco, CA2.afe87cff.jpg";